
import React from "react";

export function SwitchButton(props: SwitchButtonProps) {
    const { switchOn, onClick } = props;

    const switchClassName = switchOn ? "switch_button on" : "switch_button";

    return <div className={switchClassName} onClick={onClick}></div>;
}

export type SwitchButtonProps = {
    switchOn: boolean,
    onClick: () => void,
};
